var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 4.68629 4.68629 2 8 2H32C35.3137 2 38 4.68629 38 8V32C38 35.3137 35.3137 38 32 38H8C4.68629 38 2 35.3137 2 32V8Z",
    stroke: "#333333",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4762 12.6851C31.0022 12.6851 31.4287 13.1019 31.4287 13.6161V25.4086C31.4287 25.9228 31.0022 26.3397 30.4762 26.3397H26.6662C26.1401 26.3397 25.7137 25.9228 25.7137 25.4086V13.6161C25.7137 13.1019 26.1401 12.6851 26.6662 12.6851H30.4762ZM27.6187 14.5472H29.5237V24.4776H27.6187V14.5472Z",
    fill: "#4860AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6558 18.7295L8.12903 12.8292C7.49485 12.4364 6.66675 12.8818 6.66675 13.6157V25.4091C6.66675 26.1427 7.49438 26.5881 8.12858 26.1958L17.6554 20.3028C17.9278 20.1343 18.0746 19.8644 18.0958 19.5866L18.0959 19.4459C18.0748 19.1681 17.9281 18.8982 17.6558 18.7295ZM8.57173 15.3078V23.7181L15.3656 19.5155L8.57173 15.3078Z",
    fill: "#943939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0947 13.6157L18.0959 19.4459L18.0958 19.5866L18.0947 25.4091C18.0947 25.9233 18.5212 26.3401 19.0472 26.3401H22.8572C23.3832 26.3401 23.8097 25.9233 23.8097 25.4091V13.6157C23.8097 13.1015 23.3832 12.6846 22.8572 12.6846H19.0472C18.5212 12.6846 18.0947 13.1015 18.0947 13.6157ZM19.9997 14.5467H21.9047V24.478H19.9997V14.5467Z",
    fill: "#4860AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPause);
export default __webpack_public_path__ + "static/media/play-pause.f2601c8975b97ada4c03cd2a4eb4447f.svg";
export { ForwardRef as ReactComponent };